
import { lazy } from "react"

const CRMManagment = lazy(() => import("pages/CRMManagment/CRMManagment"))
const SaleChannel = lazy(() => import("pages/SalesChannel/index"))
const AddressCorrection = lazy(
  () => import("pages/address-correction/AddressCorrection")
)
const CRMConsignment = lazy(() => import("pages/CRM-consignment-management"))
const ConsignmentStatusDelete = lazy(() => import("pages/consignment-status-delete"))

export const childs: Array<ISideBarChild> = [

  {
    code: "",
    to: "/CRM-managment/consignment",
    component: <CRMManagment />,
    label: "گروه بندی مشتریان",
    permissions: "view_customer_group",
  },
  // {
  //   code: "",
  //   to: "/CRM-managment/salesChannel",
  //   component: <SaleChannel />,
  //   label: "کانال فروش",
  //   permissions: "view_sales_channel",
  // },
  {
    code: "",
    to: "/CRM-managment/address-correction",
    component: <AddressCorrection />,
    label: "اصلاح آدرس ",
    permissions: "view_edite_address",
  },
  {
    code: "",
    to: "/crm-consignment-manage",
    component: <CRMConsignment />,
    label: "مدیریت مرسوله",
    permissions: "view_crm_consignments_management",
  },
  {
    code: "",
    to: "/consignment-status-delete",
    component: <ConsignmentStatusDelete />,
    label: "حذف وضعیت مرسوله",
    permissions: "view_consignment_status_delete",
  },
]
